<template>
  <div class="details-index">
    <div class="page_title flex_between">
      <span>{{ pageTitle }}</span>
      <el-button type="primary" style="width: 120px" size="small" @click="back"
        >返回</el-button
      >
    </div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container" style="padding: 10px 20px 20px 20px">
        <el-tabs v-model="moduleName">
          <el-tab-pane
            label="医生开方奖励关联处方"
            name="1"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('1774') : false
            "
          ></el-tab-pane>
          <el-tab-pane
            label="医生关联用户"
            name="2"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('1779') : false
            "
          ></el-tab-pane>
          <el-tab-pane
            label="医生商城订单分佣奖"
            name="3"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('1784') : false
            "
          ></el-tab-pane>
          <el-tab-pane
            label="医生商城推荐订单分佣奖"
            name="4"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('1789') : false
            "
          ></el-tab-pane>
        </el-tabs>

        <component :is="currentComponent" />
      </div>
    </div>
  </div>
</template>

<script>
import DoctorPrescription from "./detailsComponents/DoctorPrescription.vue";
import DoctorUser from "./detailsComponents/DoctorUser.vue";
import DoctorForeverReward from "./detailsComponents/DoctorForeverReward.vue";
import DoctorRecommendReward from "./detailsComponents/DoctorRecommendReward.vue";
export default {
  data() {
    return {
      moduleName: "1",
      doctorRewardForm: {
        type: 1,
        date: [],
      },
      total: 100,
      pagination: {
        page: 1,
        pageNumber: 10,
      },
      tableHeader: [
        {
          label: "日期/月份",
          prop: "date_time",
          width: "90",
          fixed: "left",
        },
        {
          label: "邀请新用户数",
          prop: "doctor_invite",
          width: "auto",
          fixed: false,
        },
        {
          label: "激活老用户数",
          prop: "user_invite",
          width: "auto",
          fixed: false,
        },
        {
          label: "关联处方订单总金额",
          prop: "drainage_invite",
          width: "auto",
          fixed: false,
        },

        {
          label: "关联处方药品总金额",
          prop: "constitution_invite",
          width: "auto",
          fixed: false,
        },
        {
          label: "关联处方医生收益",
          prop: "alopecia_invite",
          width: "auto",
          fixed: false,
        },
        {
          label: "开方奖励总计",
          prop: "insomnia_invite",
          width: "auto",
          fixed: false,
        },
      ],
      doctorRewardData: [],
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    currentComponent() {
      switch (this.moduleName) {
        case "1":
          return DoctorPrescription;
        case "2":
          return DoctorUser;
        case "3":
          return DoctorForeverReward;
        case "4":
          return DoctorRecommendReward;
      }
    },
    pageTitle() {
      return `医生奖励统计详情-${this.$route.query.doctor_name}`;
    },
  },
  created() {},
  methods: {
    back() {
      history.back();
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
</style>
